import React, { useState, Children } from "react";
import { Route, Redirect } from "react-router-dom";

const Root = ({ children }) => {
  
  return children ;
};

export default Root;
